export enum ErrorSource {
  transaction = 'transaction',
  sessionExpired = 'sessionExpired',
}
